import CenteredContainer from '../../components/centeredContainer';

import './style.scss';
import ResetPasswordForm from "./resetPasswordForm";
import {useDispatch, useSelector} from "react-redux";
import {Navigate, useLocation} from "react-router-dom";
import {route as LOGIN_ROUTE} from "../login/"
import React, {useEffect} from "react";
import {

  clearResetPasswordApiErrors,
  clearResetPasswordTokenErrors,
  clearResetPasswordTokenSuccess
} from "../../actions/session";
import Alert from "../../components/common/alert";
import {MESSAGES, RESET_PASSWORD_TOKEN_EXPIRE_ERROR} from "../../constants";

export const route = '/reset-password';

const ResetPassword = (props) => {
  const dispatch = useDispatch();

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const token = searchParams.get('token');

  const resetPasswordSuccess = useSelector((state) => state.session.resetPasswordSuccess);
  const resetPasswordApiErrors = useSelector((state) => state.session.resetPasswordApiErrors);

  const alertApiErrors = (resetPasswordApiErrors) ? <Alert messageType='error' onDismiss={() => dispatch(clearResetPasswordApiErrors())}>{(resetPasswordApiErrors === RESET_PASSWORD_TOKEN_EXPIRE_ERROR) ? MESSAGES.RESET_PASSWORD.tokenFailure : MESSAGES.RESET_PASSWORD.resetPasswordError}</Alert> : null;

  return (resetPasswordSuccess) ? <Navigate to={LOGIN_ROUTE} /> : (
  <div className='main-content'>
    <div className='reset-password-alerts'>
      {alertApiErrors && alertApiErrors}
    </div>
    <CenteredContainer>
      <div className='login-container'>
        <ResetPasswordForm token={token}/>
      </div>
    </CenteredContainer>
  </div>
  );
};

export default ResetPassword;